import { ShiftHintDatePickerStoreSchema } from "../store";
import { mutatorAction } from "satcheljs";

/**
 * update areShiftsFetchedInStore in the shiftHintDatePickerStore instance that is passed in
 */
export default mutatorAction('SET_ARE_SHIFTS_FETCHED_IN_STORE', function setAreShiftsFetchedInStore(shiftHintDatePickerStore: ShiftHintDatePickerStoreSchema, areShiftsFetched: boolean) {
    shiftHintDatePickerStore.areShiftsFetched = areShiftsFetched;
});
